import { EditableDataObject } from "@/lib/editableData";
import { EditableData } from "@/types";
import { DeviceMessagesState } from "../generatorStore";
import { WebPageContentState } from "../webPageStore";
import {
  CampaignPageOutput,
  LandingPageOutput,
  PadPageOutput,
} from "@/data/web-pages/types.SCHEMA";

const emptyEditableStringData: EditableData<string> = {
  user: "",
  base: "",
};
export const createEmptyEditableStringData = (): EditableData<string> => ({
  ...emptyEditableStringData,
});

const emptyDeviceState: DeviceMessagesState = {
  app: new EditableDataObject({ title: "", message: "" }),
  mail: new EditableDataObject({ title: "", message: "" }),
  headunit: new EditableDataObject({ title: "", message: "" }),
  crmBlock: new EditableDataObject({ title: "", message: "" }),
};

export const createEmptyDeviceState = () => ({ ...emptyDeviceState });

const emptyWebPageContent: WebPageContentState = {
  landing: new EditableDataObject<LandingPageOutput>({
    stage: {
      title: "",
      content: "",
      overLine: "",
      type: "text",
      actions: [
        {
          text: "",
          type: "button",
          variant: "primary",
        },
      ],
    },
    intro: {
      title: "",
      content: "",
      overLine: "",
      type: "text",
      actions: [
        {
          text: "",
          type: "button",
          variant: "secondary",
        },
      ],
    },
    itemsIntro: {
      title: "",
      content: "",
      overLine: "",
      type: "text",
      actions: [
        {
          text: "",
          type: "button",
          variant: "secondary",
        },
      ],
    },
    itemList: [
      {
        title: "",
        content: "",
        type: "list-item-small",
        overLine: null,
        actions: null,
      },
      {
        title: "",
        content: "",
        type: "list-item-small",
        overLine: null,
        actions: null,
      },
      {
        title: "",
        content: "",
        type: "list-item-small",
        overLine: null,
        actions: null,
      },
    ],
  }),
  pad: new EditableDataObject<PadPageOutput>({
    stage: {
      overLine: null,
      title: "",
      content: "",
      type: "text",
      actions: [
        {
          text: "",
          type: "button",
          variant: "primary",
        },
        {
          text: "",
          type: "button",
          variant: "secondary",
        },
      ],
    },
    intro: {
      type: "text",
      title: "",
      content: "",
      overLine: "",
      actions: null,
    },
    itemList: [
      {
        title: "",
        type: "list-item-small",
        overLine: null,
        content: "",
        actions: [
          {
            text: "",
            type: "button",
            variant: "secondary",
          },
        ],
      },
      {
        title: "",
        type: "list-item-small",
        content: "",
        overLine: null,
        actions: [
          {
            text: "",
            type: "button",
            variant: "secondary",
          },
        ],
      },
      {
        title: "",
        type: "list-item-small",
        content: "",
        overLine: null,
        actions: [
          {
            text: "",
            type: "button",
            variant: "secondary",
          },
        ],
      },
    ],
    highlight: {
      title: "",
      content: "",
      overLine: "",
      type: "text",
      actions: [
        {
          text: "",
          type: "button",
          variant: "primary",
        },
      ],
    },
  }),
  campaign: new EditableDataObject<CampaignPageOutput>({
    stage: {
      type: "text",
      title: "",
      overLine: null,

      content: "",
      actions: [
        {
          text: "",
          type: "button",
          variant: "primary",
        },
        {
          text: "",
          type: "button",
          variant: "secondary",
        },
      ],
    },
    intro: {
      type: "text",
      title: "",
      content: "",
      overLine: "",
      actions: null,
    },
    itemList: [
      {
        title: "",
        type: "list-item-small",
        content: "",
        overLine: null,
        actions: [{ text: "", type: "button", variant: "secondary" }],
      },
      {
        title: "",
        type: "list-item-small",
        content: "",
        overLine: null,

        actions: [{ text: "", type: "button", variant: "secondary" }],
      },
      {
        title: "",
        type: "list-item-small",
        content: "",
        overLine: null,

        actions: [{ text: "", type: "button", variant: "secondary" }],
      },
    ],
    highlight: {
      type: "text",
      title: "",
      content: "",
      overLine: "",
      actions: [
        {
          text: "",
          type: "button",
          variant: "primary",
        },
      ],
    },
  }),
};

export const createEmptyWebPageContent = () => emptyWebPageContent;
